/* unplugin-vue-components disabled */import { render } from "./DepositView.vue?vue&type=template&id=b1795c00&lang=true"
import script from "./DepositView.vue?vue&type=script&lang=js"
export * from "./DepositView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Public\\object\\xvideos-frontend\\mysex\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__